// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

/** JQUERY **/
import './jquery-global'; // https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import

/** https://guides.rubyonrails.org/action_text_overview.html **/
import "trix"
import "@rails/actiontext"

/** ALPINEJS **/
import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'
import morph from '@alpinejs/morph'
window.Alpine = Alpine;
Alpine.plugin(mask);
Alpine.plugin(morph)
Alpine.start();

// https://turbo.hotwired.dev/handbook/drive#custom-rendering
document.addEventListener('turbo:before-render', (e) => {
  // override turbo morph with alpine morph
  // permette la copia dello stato dei componenti alpine (di cui turbo se ne frega)
  e.detail.render = (currentEl, newEl) => {
    Alpine.morph(currentEl, newEl)
  }
})

/** PLUGINS **/
// import 'flowbite';

import 'simplebar';
import 'simplebar/dist/simplebar.css';
// You will need a ResizeObserver polyfill for browsers that don't support it! (iOS Safari, Edge, ...)
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

/** CUSTOM **/
import './main';